const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path fill="currentColor" d="M0 12a3.25 3.25 0 1 0 6.5 0A3.25 3.25 0 1 0 0 12"></path><path fill="currentColor" d="M8.75 12a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0"></path><path fill="currentColor" d="M17.5 12a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0"></path></g></svg>';
export {
  t as default
};
